import React from 'react';

const PrintHotel = ({ values, penilaian, id, print }) => {
  return (
    <button
      disabled={ !penilaian.original.data[ 0 ].result }
      className='btn btn-success'
      onClick={ () => print(id,values.type) }>
      Cetak Sertifikat
    </button>
  );
};

const PrintHotelEdit = ({ values, penilaian, id, printEdit }) => {
  return (
    <button
      disabled={ !penilaian.original.data[ 0 ].result }
      className='btn btn-info'
      onClick={ () => printEdit(id,values.type) }>
      edit
    </button>
  );
};

export default PrintHotel;
export {PrintHotelEdit}